export default {"src":"/_next/static/media/bankDark.1309e7e8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};